import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import Sidebar from '../../components/Sidebar';
import Topbar from '../../components/Topbar';
import Tabs from '../../components/Tabs';
import ProductsTable from '../../components/ProductsTable';
import FilesPanel from '../../components/FilesPanel';
import ActivityPanel from '../../components/ActivityPanel';
import { getProposalDetail } from '../../services/mockProposalDetail';

export default function ProposalDetail(){
  const { id } = useParams();
  const [d, setD] = useState(null);
  const [tab, setTab] = useState('resumo');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let mounted = true;
    async function load() {
      setLoading(true);
      setError(null);
      try {
        const res = await getProposalDetail(id);
        if (mounted) setD(res);
      } catch (err) {
        if (mounted) setError(err.message || 'Erro ao carregar o detalhe');
      } finally {
        if (mounted) setLoading(false);
      }
    }
    load();
    return () => (mounted = false);
  }, [id]);

  function handleRetry() {
    setError(null);
    setLoading(true);
    getProposalDetail(id).then(res => { setD(res); setLoading(false); }).catch(err => { setError(err.message || 'Erro'); setLoading(false); });
  }

  if (loading && !d) return <div className="min-h-screen flex items-center justify-center">Carregando...</div>;
  if (error) return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="p-6 bg-red-50 text-red-700 rounded">
        <div>Erro ao carregar orçamento: {error}</div>
        <div className="mt-3 text-right"><button onClick={handleRetry} className="px-3 py-1 bg-red-100 text-red-700 rounded">Tentar novamente</button></div>
      </div>
    </div>
  );

  const tabs = [
    { key: 'resumo', label: 'Resumo' },
    { key: 'cliente', label: 'Cliente' },
    { key: 'produtos', label: 'Produtos e Serviços' },
    { key: 'valores', label: 'Valores' },
    { key: 'contrato', label: 'Contrato' },
    { key: 'arquivos', label: 'Arquivos' },
    { key: 'historico', label: 'Histórico' }
  ];

  return (
    <div className="flex bg-gray-50 min-h-screen">
      <Sidebar />
      <div className="flex-1">
        <Topbar user={{ name: d.responsible?.name || 'Mateus Teixeira' }} />

        <main className="p-6 max-w-7xl mx-auto">
          <div className="flex items-start justify-between gap-6 mb-6">
            <div>
              <span className="text-sm text-gray-400">‹ Voltar para orçamentos</span>
              <h2 className="text-2xl font-bold mt-2">{d.title} {/* <span className="ml-3 px-3 py-1 rounded-full bg-violet-100 text-violet-700 text-sm">{d.status}</span> */}</h2>
              <div className="text-sm text-gray-500 mt-1">Cliente: {d.client}</div>
              <div className="text-xs text-gray-400 mt-1">Criado em {d.createdAt}</div>
            </div>

            <div className="flex items-center gap-4">
              <div className="bg-white rounded-2xl p-4 border">
                <div className="text-sm text-gray-500">Valor total</div>
                <div className="text-xl font-semibold">R$ {d.total.toLocaleString('pt-BR')}</div>
              </div>
              <button className="px-4 py-2 bg-purple-600 text-white rounded-2xl">Editar orçamento</button>
            </div>
          </div>

          <Tabs tabs={tabs} active={tab} onChange={setTab} />

          <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 mt-6">
            <div className="lg:col-span-2 space-y-6">
              {tab === 'resumo' && (
                <>
                  <div className="bg-white rounded-2xl p-6 border grid grid-cols-1 md:grid-cols-2 gap-6">
                    <div>
                      <h4 className="font-medium mb-3">Informações principais</h4>
                      <div className="text-sm text-gray-600">
                        <div><strong>Código do orçamento</strong> · {d.id}</div>
                        <div><strong>Modelo escolhido</strong> · C Interno & Externo</div>
                        {/* Status atual temporarily hidden
                        <div><strong>Status atual</strong> · {d.status}</div>
                        */}
                        <div><strong>Prazo de produção</strong> · 45 dias úteis</div>
                        <div><strong>Serviços selecionados</strong> · {d.products.length} serviços</div>
                      </div>
                    </div>

                    <div>
                      <h4 className="font-medium mb-3">Resumo financeiro</h4>
                      <div className="text-sm text-gray-600">
                        <div className="flex justify-between"><span>Subtotal</span><span>R$ {d.subtotal.toLocaleString('pt-BR')}</span></div>
                        <div className="flex justify-between"><span>Desconto</span><span>R$ {d.discount.toLocaleString('pt-BR')}</span></div>
                        <div className="flex justify-between"><span>Impostos (5%)</span><span>R$ {d.taxes.toLocaleString('pt-BR')}</span></div>
                        <div className="mt-4 flex justify-between text-lg font-semibold"><span>Valor total</span><span>R$ {d.total.toLocaleString('pt-BR')}</span></div>
                        <div className="mt-3 p-3 bg-green-50 rounded-lg text-sm text-green-700">Margem estimada {d.marginPct}% · Lucro estimado R$ {d.estimatedProfit.toLocaleString('pt-BR')}</div>
                      </div>
                    </div>
                  </div>

                  <ProductsTable items={d.products} />

                  <div className="bg-white rounded-2xl p-4 border">
                    <div className="flex items-center justify-between">
                      <h4 className="font-medium">Observações internas</h4>
                      <button className="text-sm text-purple-600">Editar</button>
                    </div>
                    <div className="mt-3 text-sm text-gray-600">Cliente solicitou destaque para área gourmet e integração com piscina.</div>
                  </div>
                </>
              )}
            </div>

            <div className="space-y-6">
              <ActivityPanel activities={d.activities} />
              <FilesPanel files={d.files} />
            </div>
          </div>
        </main>
      </div>
    </div>
  );
}
